import {ChangeDetectorRef, Component, EventEmitter, HostBinding, OnInit, Output} from '@angular/core';
import {SplashScreenService} from "./splash-screen.service";

@Component({
  selector: 'app-splash-screen',
  templateUrl: './splash-screen.component.html',
  styleUrls: ['./splash-screen.component.scss']
})
export class SplashScreenComponent implements OnInit {
  @HostBinding('class.splash-hidden') invisible: boolean = true;
  @HostBinding('class.hidden') hidden: boolean = false;
  @Output() hide: EventEmitter<string> = new EventEmitter();


  constructor(private splashScreenService: SplashScreenService,
              private changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.splashScreenService.set(this);
  }

  public setVisible(v: boolean) {
    this.invisible = !v;
    if(this.invisible) {
      this.hide.emit();
      window.setTimeout(() => {
        this.hidden = true;
      }, 600)
    }
    //this.changeDetectorRef.markForCheck();
  }

}
